import { render, staticRenderFns } from "./batchQualityEdit.vue?vue&type=template&id=a99847e2&scoped=true&"
import script from "./batchQualityEdit.vue?vue&type=script&lang=js&"
export * from "./batchQualityEdit.vue?vue&type=script&lang=js&"
import style0 from "./batchQualityEdit.vue?vue&type=style&index=0&id=a99847e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99847e2",
  null
  
)

export default component.exports